import { useMemo } from "react";

import numeral from "numeral";

import { ProgressBarWithValueCell, type ColumnType } from "@similarweb/pro-logic-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

import { NoDataCell } from "../../../components/NoDataCell";

export interface IShareColumnData {
    share?: number | null;
}

export const useShareColumnConfig = () => {
    const translate = useTranslation();

    return useMemo(
        () =>
            ({
                title: translate("bt.report.channels.website-traffic-share-table.share-column.title"),
                dataIndex: "share",
                minWidth: 180,
                render: (value) => {
                    if (value == null) {
                        return (
                            <Flex
                                flexGrow="1"
                                justifyContent="end"
                            >
                                <NoDataCell />
                            </Flex>
                        );
                    }

                    return (
                        <ProgressBarWithValueCell
                            share={value}
                            value={numeral(value).format("0.00%")}
                        />
                    );
                },
            }) satisfies ColumnType<IShareColumnData>,
        [translate],
    );
};
